export default {
  reportBuilder: 'Report Builder',
  subheadline: 'These settings define the global appearance of PDFs generated by Qmulus.',
  reportForm: {
    size: {
      label: 'Default paper size',
      tooltip: 'Defines the paper size that is always preselected.',
    },
    language: {
      label: 'Language',
      tooltip: 'The language selection controls how timestamps and other localized text fragments are displayed in the report.',
    },
    logo: {
      label: 'Logo',
      tooltip: 'The selected logo is displayed in the header of every report.',
    },
    header: {
      height: {
        tooltip: 'Defines the header height used on every report page.',
      },
      contentLeft: {
        tooltip: 'Defines the left header text shown on every report page.',
      },
      contentCenter: {
        tooltip: 'Defines the centered header text shown on every report page.',
      },
      contentRight: {
        tooltip: 'Defines the right header text shown on every report page.',
      },
    },
    footer: {
      contentLeft: {
        tooltip: 'Defines the left footer text shown on every report page.',
      },
      contentCenter: {
        tooltip: 'Defines the centered footer text shown on every report page.',
      },
      contentRight: {
        tooltip: 'Defines the right footer text shown on every report page.',
      },
    },
  },
  errors: {
    unsupportedFileType: 'The current logo is in an unsupported file format. Please upload a new logo.',
    logoLoadingFailure: 'The current logo could not be loaded. We recommend uploading a new logo.',
  },
};
